export enum GroupEnum {
  Administrator = "Administrator",
  Staff = "Staff",
  HouseMaker = "HouseMaker",
  RealEstateAgency = "RealEstateAgency",
  RealEstateAgencyFree = "RealEstateAgencyFree"
}
